module.exports = __webpack_public_path__ + "img/promo-banner.c95542b7.png";